import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function scrollIntoViewIfNeeded(opts: {
	selector: string;
	containerSelector?: string;
	scrollBehavior?: "instant" | "smooth";
	threshold?: number;
	block?: "start" | "end" | "center" | "nearest";
}) {
	const {
		selector,
		containerSelector,
		scrollBehavior = "instant",
		threshold = 1.0,
		block = "nearest",
	} = opts;
	const element = document.querySelector(selector);
	if (!element) return;

	const observer = new IntersectionObserver(
		(entries) => {
			if (!entries[0].isIntersecting) {
				element.scrollIntoView({ behavior: scrollBehavior, block });
			}
			observer.disconnect();
		},
		{
			root: containerSelector ? document.querySelector(containerSelector) : null,
			threshold,
		},
	);

	observer.observe(element);
	requestAnimationFrame(observer.disconnect);
}
